'use client';

import { c as _c } from "react/compiler-runtime";
import { maskitoTransform } from '@maskito/core';
import { useTranslation } from 'react-i18next';
import { toTwoDigitDateString } from '@sola/utils/date.ts';
import { InputField, InputFieldProps } from '../input-field/input-field';
import { useCreditCardFields } from './utils';
export type CardExpiryFieldProps = Omit<InputFieldProps, 'maskOptions' | 'placeholder' | 'prefix' | 'type' | 'minLength' | 'maxLength' | 'pattern'> & {
  // If true, disallows entering the current month
  validateCurrentMonth?: boolean;
};
export const CardExpiryField: React.FC<CardExpiryFieldProps> = t0 => {
  const $ = _c(18);
  let fieldProps;
  let validateCurrentMonth;
  if ($[0] !== t0) {
    ({
      validateCurrentMonth,
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = fieldProps;
    $[2] = validateCurrentMonth;
  } else {
    fieldProps = $[1];
    validateCurrentMonth = $[2];
  }
  const {
    validator
  } = useCreditCardFields();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["checkout"];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = toTwoDigitDateString(new Date());
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const formattedDate = t2;
  const handleChange = _temp;
  let t3;
  if ($[5] !== t) {
    t3 = t("checkout:form.billingFields.expirationDateLabel");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t || $[8] !== validateCurrentMonth || $[9] !== validator) {
    t4 = value_0 => {
      const {
        isValid
      } = validator.expirationDate(value_0);
      if (!isValid) {
        return t("checkout:form.card.expiryInvalid");
      }
      if (validateCurrentMonth && formattedDate === value_0) {
        return t("checkout:form.card.expiryInvalid");
      }
    };
    $[7] = t;
    $[8] = validateCurrentMonth;
    $[9] = validator;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("checkout:form.billingFields.expirationDatePlaceholder");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== fieldProps || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <InputField autoComplete="cc-exp" inputMode="numeric" label={t3} validate={t4} onChange={handleChange} placeholder={t5} {...fieldProps} />;
    $[13] = fieldProps;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
function _temp(e) {
  let {
    value
  } = e.target;
  if (value.length === 1 && !value.match("0|1")) {
    value = `0${value}`;
  }
  e.target.value = maskitoTransform(value, {
    mask: [...new Array(2).fill(/\d/), "/", ...new Array(2).fill(/\d/)]
  });
}